import React from 'react'

const BookSparklesIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width='42'
    height='45'
    viewBox='0 0 42 45'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path d='M4.41667 32.1981C4.76389 32.0939 5.10243 32.0071 5.43229 31.9377C5.76215 31.8682 6.11806 31.8335 6.5 31.8335H8.58333V6.8335H6.5C5.90972 6.8335 5.41493 7.03315 5.01562 7.43245C4.61632 7.83176 4.41667 8.32655 4.41667 8.91683V32.1981ZM6.5 44.3335C4.76389 44.3335 3.28819 43.7259 2.07292 42.5106C0.857639 41.2953 0.25 39.8196 0.25 38.0835V8.91683C0.25 7.18072 0.857639 5.70502 2.07292 4.48975C3.28819 3.27447 4.76389 2.66683 6.5 2.66683H21.0833V6.8335H12.75V31.8335H25.25V25.5835H29.4167V36.0002H6.5C5.90972 36.0002 5.41493 36.1998 5.01562 36.5991C4.61632 36.9984 4.41667 37.4932 4.41667 38.0835C4.41667 38.6738 4.61632 39.1686 5.01562 39.5679C5.41493 39.9672 5.90972 40.1668 6.5 40.1668H33.5833V23.5002H37.75V44.3335H6.5ZM30.4583 23.5002C30.4583 20.3057 31.5694 17.5974 33.7917 15.3752C36.0139 13.1529 38.7222 12.0418 41.9167 12.0418C38.7222 12.0418 36.0139 10.9307 33.7917 8.7085C31.5694 6.48627 30.4583 3.77794 30.4583 0.583496C30.4583 3.77794 29.3472 6.48627 27.125 8.7085C24.9028 10.9307 22.1944 12.0418 19 12.0418C22.1944 12.0418 24.9028 13.1529 27.125 15.3752C29.3472 17.5974 30.4583 20.3057 30.4583 23.5002Z' />
  </svg>
)

export default BookSparklesIcon
